import logreg from '../js/logreg';
export default {
  name: 'emailinput',
  props: {
    mb: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      email: '',
      errorTxt: ''
    };
  },
  components: {},
  methods: {
    emailInput: function emailInput() {
      this.emailCheck();
      this.$emit('changeErrorTxt', this.errorTxt);
      this.$emit('changeEmail', this.email);
    },
    emailBlur: function emailBlur() {
      this.emailCheck(true);
      this.$emit('changeErrorTxt', this.errorTxt);
    },
    emailCheck: function emailCheck(state) {
      if (!this.email) {
        this.errorTxt = this.$t(this.$loginLangPrefix('userSign.webLoginEmailTips'));
      } else if (logreg.validate(this.email, 'email')) {
        this.errorTxt = '';
      } else if (state) {
        this.errorTxt = this.$t(this.$loginLangPrefix('userSign.webLoginEmailTips'));
      }
    },
    deleteInput: function deleteInput() {
      this.email = '';
      this.emailInput();
    },
    next: function next() {
      this.$emit('btnSure');
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};